import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { GetNotificationsRequestDto, type NotificationsPageResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/useApiClient.util.ts';

type Params = GetNotificationsRequestDto;

type Return = {
  isLoading?: boolean;
  notifications?: NotificationsPageResponseDto;
};

export const useGetNotifications = (params: Params, refetch: false | number = false): Return => {
  const { restNotificationControllerApi } = useApiClient();

  const { data, isLoading } = useQuery<NotificationsPageResponseDto, AxiosError>({
    queryFn: async () => {
      const { data } = await restNotificationControllerApi.getNotifications(params);
      return data;
    },
    queryKey: [QueryKeyEnum.NOTIFICATIONS, params],
    refetchInterval: refetch,
  });

  return {
    isLoading,
    notifications: data,
  };
};
